/* eslint jsx-a11y/anchor-has-content: 0 */
import React from 'react';

import cn from 'classnames';
import { isEmpty, noop } from 'lodash';
import { shape, node, bool, func, string, number } from 'prop-types';
import { withState } from 'recompose';

import Chip from '@mui/material/Chip';

import CommonAvatar from 'components/Common/Avatar';
import { ensureString } from 'utils/string';

import s from './Avatar.css';

@withState('imgLoadError', 'setImgLoadError', false)
export default class Avatar extends React.Component {
  componentDidUpdate({ profilePic }) {
    // eslint-disable-next-line react/destructuring-assignment
    if (profilePic !== this.props.profilePic) this.props.setImgLoadError(false);
  }

  render() {
    const {
      profilePic,
      style,
      children,
      imgProps,
      imgLoadError,
      setImgLoadError,
      firstName,
      lastName,
      withName,
      name,
      className,
      variant,
      tabIndex,
      role,
      ...restProps
    } = this.props;

    const src = imgLoadError ? undefined : profilePic;
    const initials = [ensureString(firstName), ensureString(lastName)].reduce(
      (a, b) => `${a}${ensureString(b.substring(0, 1))}`,
      '',
    );

    const avatar = (
      <CommonAvatar
        size="sm"
        className={cn(s.avatar, className)}
        src={src}
        variant={variant}
        imgProps={
          isEmpty(imgProps)
            ? {
                onError: () => {
                  setImgLoadError(true);
                },
              }
            : imgProps
        }
        {...restProps}
      >
        {isEmpty(children) && name ? initials : children}
      </CommonAvatar>
    );

    return withName && name ? (
      <Chip
        classes={{
          outlined: s.chip,
          clickable: s.clickable,
        }}
        role={role}
        tabIndex={tabIndex}
        avatar={avatar}
        label={name}
        variant="outlined"
        clickable
      />
    ) : (
      avatar
    );
  }
}

Avatar.propTypes = {
  style: shape({}),
  imgProps: shape({}),

  children: node,

  imgLoadError: bool,
  setImgLoadError: func,

  profilePic: string,
  firstName: string,
  lastName: string,
  name: string,
  className: string,

  withName: bool,
  variant: string,
  tabIndex: number,
  role: string,
};

Avatar.defaultProps = {
  style: {},
  children: undefined,
  imgProps: {},
  profilePic: undefined,
  firstName: '',
  lastName: '',
  name: '',
  withName: false,
  className: undefined,
  imgLoadError: false,
  setImgLoadError: noop,
  variant: 'circular',
  tabIndex: undefined,
  role: undefined,
};
